import { Language } from "@/contexts/LanguageContext";
import { isUrlPrefixLanguage } from "@/constants/urlLangPrefix";

/**
 * Get a localized URL path based on the current language
 * @param path - The base path (e.g., '/accommodations')
 * @param language - The current language code
 * @returns The localized path (e.g., '/de/accommodations' for German)
 */
export const getLocalizedUrl = (path: string, language: Language): string => {
  // Remove leading slash if present for consistency
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  // English doesn't need a prefix
  if (language === 'en') {
    return cleanPath;
  }
  
  // Add language prefix for other languages
  return `/${language}${cleanPath}`;
};

/**
 * Get the current page path without language prefix
 * Useful for navigation items to determine active state
 */
export const getPathWithoutLanguage = (pathname: string): string => {
  const pathParts = pathname.split('/').filter(Boolean);
  
  // Check if first segment is a language code
  if (isUrlPrefixLanguage(pathParts[0])) {
    // Remove language prefix and return the rest
    return '/' + pathParts.slice(1).join('/') || '/';
  }
  
  return pathname || '/';
};

